import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import List from './List';
import { getRequestsVessel } from 'actions/vessels/request';

import styles from 'styles/index';

class RequestsPage extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getRequestsVessel({
            page: 1,
            filters: {
                all: true,
            },
            sort: {
                field: 'addedAt',
                value: -1,
            },
        });
    }

    render() {
        return (
            <div id='vessel-requests' className='requests-page page'>
                <CircularProgress
                    className={!this.props.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            Vessel requests
                        </h2>
                        <List />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLogged: state.user.isLogged,
            isLoaded: state.vesselRequests.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getRequestsVessel,
    },
    dispatch),
)(RequestsPage);



// WEBPACK FOOTER //
// ./app/components/Vessels/Requests/Page.jsx